import { BringgFontIcons } from '@bringg/bringg-icons';
import React from 'react';
import { Row } from 'react-table';
import classNames from 'classnames';
import './table-row.scss';

interface ReactTableRowProps<T extends object> {
	row: Row<T>;
	expandIconName?: BringgFontIcons;
	children?: React.ReactNode;
	tableRowClass?: string;
	tableCellClass?: string;
	tableCellTextClass?: string;
}

const CELL = 'Cell';

const TableRow = <T extends object>(props: ReactTableRowProps<T>) => {
	const { children, row, tableRowClass, tableCellClass, tableCellTextClass } = props;

	return (
		<>
			<div
				{...row.getRowProps()}
				{...(row.getToggleRowExpandedProps && { ...row.getToggleRowExpandedProps() })}
				className={classNames('bringg-table-row', tableRowClass)}
				data-test-id={`bringg-table-row-${row.id}`}
			>
				{children
					? children
					: row.cells.map((cell, index) => (
							<div
								{...cell.getCellProps()}
								className={classNames('bringg-table-cell', tableCellClass)}
								data-test-id="bringg-table-cell"
								key={`${row.id}-${index}}`}
							>
								<div
									title={typeof cell.value === 'string' ? cell.value : ''}
									className={classNames('bringg-table-cell-text', tableCellTextClass)}
								>
									{!cell.isPlaceholder && cell.render(CELL)}
								</div>
							</div>
					  ))}
			</div>
		</>
	);
};

export default TableRow;
